import script from "./ButtonStrip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonStrip.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonStrip.vue?vue&type=style&index=0&id=4cf9f3dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf9f3dc"]])

export default __exports__